// extracted by mini-css-extract-plugin
export var dark = "styles-module--dark--e7c41";
export var description = "styles-module--description--254ef";
export var light = "styles-module--light--9b31c";
export var text = "styles-module--text--9d1e8";
export var title = "styles-module--title--beac8";
export var transparent = "styles-module--transparent--d7a21";
export var video = "styles-module--video--3df1d";
export var wrapper = "styles-module--wrapper--2a0ca";